import React from "react";
import { Dialog, DialogContent, Typography, Slide, Box } from "@mui/material";

const SlideTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
  title: {
    fontWeight: "bold",
    fontSize: "22px",
    color: "#033E8C",
  },
  description: {
    fontSize: "16px",
    color: "#055C9D",
    fontWeight: 500,
    lineHeight: 1.6,
  },
  subDescription: {
    fontSize: "15px",
    color: "#444",
    fontWeight: 400,
    marginTop: "12px",
    lineHeight: 1.5,
  },
};

const instructionMap = {
  "Photos Plan": {
    title: "Photo Service",
    description: (
      <>
        <Typography sx={styles.description}>
          Click where you want a photo taken.
          <br />
          Click & hold on the blue camera to rotate its direction.
          <br />
          Place as many as you like.
        </Typography>
      </>
    ),
  },
  "Videos Plan": {
    title: "Video Service",
    description: (
      <>
        <Typography sx={styles.description}>
          Click once to start a video path. Click again at the end.
          <br />
          Make more video paths by selecting the line tool.
          <br />
          Create an orbit path by selecting the circle.
        </Typography>
      </>
    ),
  },
  "Photogrammetry Plan": {
    title: "Photogrammetry",
    description: (
      <>
        <Typography sx={styles.description}>
          Create the boundary of your photomap:
          <ul style={{ listStyleType: "none" }}>
            <li>Click once to start.</li>
            <li>Click again to set a corner.</li>
            <li>Double Click to finish.</li>
          </ul>
        </Typography>
        <Typography sx={styles.subDescription}>
          Anything inside the area will be captured. Remember to capture
          important areas like roads, utilities, markers and ground control
          locations.
        </Typography>
      </>
    ),
  },
  "Lidar Plan": {
    title: "Photogrammetry and LiDAR",
    description: (
      <>
        <Typography sx={styles.description}>
          Create the boundary of your LiDAR scan:
          <ul style={{ listStyleType: "none" }}>
            <li>Click once to start.</li>
            <li>Click again to set a corner.</li>
            <li>Double Click to finish.</li>
          </ul>
        </Typography>
        <Typography sx={styles.subDescription}>
          Anything inside the area will be captured. Remember to capture
          important areas like roads, utilities, markers and ground control
          locations.
        </Typography>
      </>
    ),
  },
  "Ground Control Points Plan": {
    title: "Ground Control Points Plan",
    description: (
      <>
        <Typography sx={styles.description}>
          Click to place ground control locations.
          <br />
        </Typography>
        <Typography sx={styles.subDescription}>
          Please note if they are existing or if we need to mark them for you to
          locate at a later time.
          <br /> Please ensure your photogrammetry or lidar capture zones fly
          above your ground control.
        </Typography>
      </>
    ),
  },
};

export default function InstructionOverlay({ type = null, onClose }) {
  if (!type) return null;

  const { title, description } = instructionMap[type] || {
    title: "Instructions",
    description: (
      <Typography>No instructions available for this type.</Typography>
    ),
  };

  return (
    <Dialog
      open={!!type}
      onClose={onClose}
      TransitionComponent={SlideTransition}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        onClick: onClose,
      }}
      maxWidth="sm"
    >
      <DialogContent
        onClick={(e) => e.stopPropagation()}
        sx={{
          textAlign: "center",
          backgroundColor: "#fff",
          padding: 5,
          borderRadius: 3,
          boxShadow: 4,
        }}
      >
        <Typography sx={styles.title}>{title}</Typography>
        <Box mt={3}>{description}</Box>
      </DialogContent>
    </Dialog>
  );
}
